<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick, watch } from 'vue'

const props = defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})

const titleContent = ref(null)
const decorationContainer = ref(null)
const maxHeight = ref(0)

const trackMaxHeight = () => {
  nextTick(() => {
    const cardElements = document.querySelectorAll('.recensione-card')
    let maxHeightValue = 0
    cardElements.forEach((card) => {
      const height = card.offsetHeight
      if (height > maxHeightValue) {
        maxHeightValue = height
      }
    })
    maxHeight.value = maxHeightValue

    cardElements.forEach((card) => {
      card.style.height = `${maxHeight.value}px`
    })
  })
}

onMounted(() => {
  trackMaxHeight()
  positionDecorationImage(props.block.parolaTarget)
  window.addEventListener('resize', trackMaxHeight)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', trackMaxHeight)
})

watch(
  () => props.block.bloccoRecensione,
  () => {
    trackMaxHeight()
  },
  { deep: true },
)

function positionDecorationImage(targetWord) {
  if (titleContent.value && decorationContainer.value) {
    const htmlContent = titleContent.value
    const decorationContainerElement = decorationContainer.value

    const targetWordIndex = htmlContent.innerHTML.indexOf(targetWord)
    if (targetWordIndex === -1) {
      console.warn(`Word "${targetWord}" not found in the content.`)
      return
    }

    const beforeTargetWord = htmlContent.innerHTML.substring(0, targetWordIndex)
    const afterTargetWord = htmlContent.innerHTML.substring(
      targetWordIndex + targetWord.length,
    )

    htmlContent.innerHTML = `${beforeTargetWord}<span class="target-word">${targetWord}</span>${afterTargetWord}`

    const targetWordElement = htmlContent.querySelector('.target-word')
    if (targetWordElement) {
      targetWordElement.appendChild(decorationContainerElement)
    }
  }
}
</script>

<template>
  <div class="sezione-recensioni p-bottom-xl-1">
    <div class="container">
      <!-- eslint-disable vue/no-v-html -->
      <div class="text-content">
        <div
          ref="titleContent"
          class="title-base title"
          v-html="block.titolo"
        />
        <div
          v-if="block.sottotitolo"
          class="text-s-1-b under-title"
          v-html="block.sottotitolo"
        />
        <div
          v-if="block.immagineDecorativa"
          ref="decorationContainer"
          class="decoration-img-container custom-position"
        >
          <DecorationImage
            :image="block.immagineDecorativa.immagine"
            :type="block.immagineDecorativa.titolo"
          />
        </div>
        <div class="recensioni-grid">
          <div
            v-for="recensione in block.bloccoRecensione"
            :key="recensione.id"
            class="recensione-card"
          >
            <div
              class="recensione-text text-s-1-b"
              v-html="recensione.testo"
            ></div>
            <p
              v-if="recensione.autore"
              class="recensione-author text-xxs-1"
              v-html="recensione.autore"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Recensioni',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
